import {
    GetProductGroupListResponseSchema,
    GetSupportedUnitListResponseSchema,
    ListResponseBody,
} from '@schuettflix/interfaces';
import { z } from 'zod';
import { useHttpClientContext } from '@/shared/context/HttpClientContext.tsx';

export const useGetOrderProductGroupsApi = () => {
    const { orderClient } = useHttpClientContext();

    return {
        getOrderProductGroups: async (orderId: string) => {
            return orderClient
                .get<ListResponseBody<z.input<typeof GetProductGroupListResponseSchema>>>('/v1/product-groups', {
                    params: {
                        orderId,
                    },
                })
                .then(res => res.data.items.map(item => GetProductGroupListResponseSchema.parse(item)));
        },
    };
};

export const useGetSupportedUnitsByProductType = () => {
    const { orderClient } = useHttpClientContext();

    return {
        getSupportedUnitsByProductType: async (productType: string) => {
            return orderClient.get<ListResponseBody<z.infer<typeof GetSupportedUnitListResponseSchema>>>(
                `/v1/product-type/${productType}/supported-units`
            );
        },
    };
};
